import { Amounts } from '@/components/Amounts';
import { BillingAddress } from '@/components/BillingAddress';
import { DiscountCodeEntry } from '@/components/DiscountCodeEntry';
import { DiscountTags } from '@/components/DiscountTags';
import { GiftCards } from '@/components/GiftCards';
import { Heading } from '@/components/Heading';
import { InlinedAside } from '@/components/InlinedAside';
import { LoyaltyCard } from '@/components/LoyaltyCard';
import { PaymentOptions } from '@/components/PaymentOptions';
import { useUser } from '@/contexts/userContext';
import type { CartServiceMessage, PaymentAmounts } from '@/types';
import * as Styled from './Payment.styled';
import { usePageData } from '../../contexts/pageContext';

interface PaymentProps {
  data: {
    amounts: PaymentAmounts | null;
    cartServiceMessage: CartServiceMessage | null;
    discountCode: string | null;
  };
}

export const Payment = ({
  data: { amounts, cartServiceMessage, discountCode },
}: PaymentProps) => {
    const { isAuthenticated } = useUser();
    const { isLoyaltyEnabled, isGiftCardsEnabled } = usePageData();
  return (
    <Styled.PaymentSection>
      <Styled.SectionHeader>
        <Heading level={2}>Payment</Heading>
        <Styled.Text>All transactions are secure and encrypted</Styled.Text>
      </Styled.SectionHeader>
      <PaymentOptions />
          {isAuthenticated && isLoyaltyEnabled ? <LoyaltyCard /> : null}
          {isGiftCardsEnabled ? <GiftCards /> : null}
      <BillingAddress />
      {cartServiceMessage ? (
        <InlinedAside content={cartServiceMessage} />
      ) : null}
      <DiscountCodeEntry />
      {discountCode ? <DiscountTags discountCode={discountCode} /> : null}
      <Amounts amounts={amounts} />
    </Styled.PaymentSection>
  );
};
